import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { CircularProgress, withStyles } from '@material-ui/core';
import useLocale from '@/hooks/useLocale';
import { ssoAcceptActions } from '@/redux/modules';
import styles from './styles';

const SsoAcceptPage = ({ classes, location }) => {
  const dispatch = useDispatch();
  const { ssoAccept: locale } = useLocale();
  const { error } = useSelector(state => state.ssoAccept);

  const acceptSsoFromQuery = () => {
    const params = new URLSearchParams(location.search);
    const jwt = params.get('jwt');
    dispatch(ssoAcceptActions.request({ jwt }));
  };

  useEffect(acceptSsoFromQuery, [location.search, dispatch]);

  return (
    <div className={classes.container}>
      {error ? (
        <p>
          {locale.authErrorPrefix}
          {error}
        </p>
      ) : (
        <>
          <p>{locale.authenticating}</p>
          <CircularProgress size={50} />
        </>
      )}
    </div>
  );
};

export default withRouter(withStyles(styles)(SsoAcceptPage));
